import React, { useEffect, useState } from 'react';
import '../css/mines.css';
import '../css/popup.css';
import Header from '../components/header';
import UserMine from '../components/userMine';
import UserMineAdmin from '../components/userMineAdmin';
import Modal from '../components/popupModalMines';
import { fetchMines, deleteMyMine, createMine, inviteUser, removeUserFromMine, } from '../Utility/Mines/minesFunctions';

function Mines() {
    const [mines, setMines] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [mineName, setMineName] = useState('');
    const [inviteEmail, setInviteEmail] = useState('');

    useEffect(() => {
        fetchMines(setMines, setLoading, setError);
    }, []);

    const handleCreateMine = async (e) => {
        e.preventDefault();
        try {
            await createMine(mineName, setMines, mines, setMineName);
            setIsSuccessModalOpen(true);
        } catch (err) {
            console.error(err);
        }
    };

    const handleDeleteMine = async () => {
        try {
            await deleteMyMine(mines._id);
            window.location.reload();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <Header />
            <div className="riga">
                <h3 className="titolo titoloManage">YOUR MINES</h3>
                <span className="text">
                    A mine is your personal workspace where you can store all your results and access platform tools via your <a href="/dashboard">dashboard</a>. It also lets you invite others to collaborate on projects and share data seamlessly.
                </span>
                <div className="space"></div>
            </div>
            <div className="riga">
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <div className="create-mine-form">
                        <h3 className="titolo popupTitle">Create your first Mine</h3>
                        <p className="text">You must create a mine to continue!</p>
                        <form onSubmit={handleCreateMine}>
                            <input
                                type="text"
                                id="MineName"
                                name="MineName"
                                placeholder="Enter your Mine name..."
                                value={mineName}
                                onChange={(e) => setMineName(e.target.value)}
                                required
                            />
                            <button type="submit" className="sign-button button">Create Mine</button>
                        </form>
                    </div>
                ) : (
                    <div className="MineArea" key={mines.tokens}>
                        <div className="TitleMineArea">
                            <h3 className="titolo MineTitle">{mines.name}'s users</h3>
                        </div>
                        <div className="ButtonMineArea">
                            <p>
                                &nbsp;
                                <button type="button" className="button buttonUser dangerbutton" onClick={() => setIsDeleteModalOpen(true)}>
                                    Delete Mine
                                </button>
                            </p>
                        </div>
                        <div key={mines.admin._id}>
                            <UserMineAdmin email={mines.admin.email} role="Admin" />
                        </div>
                        {mines.users && mines.users.length > 0 ? (
                            mines.users.map((user) => (
                                <div key={user._id}>
                                    <UserMine
                                        email={user.email}
                                        role="User"
                                        onDelete={() => removeUserFromMine(user._id, mines._id)}
                                    />
                                </div>
                            ))
                        ) : (
                            <div></div>
                        )}
                        <div className="TitleMineArea">
                            <h3 className="titolo MineTitle">TOKENS: ({mines.tokens})</h3>
                        </div>
                        
                    </div>
                )}
            </div>

            {/* Modal per invitare un utente */}
            <Modal
                isOpen={isInviteModalOpen}
                title="Invite a New Collaborator"
                message="Type in the email of the user you want to invite. This user must be already registered to the platform!"
                onClose={() => setIsInviteModalOpen(false)}
            >
                <form onSubmit={(e) => {
                    e.preventDefault();
                    inviteUser(inviteEmail, mines);
                }}>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Enter collaborator email..."
                        value={inviteEmail}
                        onChange={(e) => setInviteEmail(e.target.value)}
                        required
                    />
                    <button type="submit" className="sign-button button">Add Collaborator</button>
                </form>
            </Modal>

            {/* Modal di successo per la creazione della mine */}
            <Modal
                isOpen={isSuccessModalOpen}
                title="Mine Created Successfully!"
                message="Your mine has been created. You can now access all the tools of the platform via your dashboard. Please ensure you have enough tokens available."
                onClose={() => (window.location.href = "/dashboard")}
            >
                <button
                    type="button"
                    className="sign-button button"
                    onClick={() => window.location.href = "/dashboard"}
                >
                    Go to Dashboard
                </button>
            </Modal>

            {/* Modal di conferma per la cancellazione della mine */}
            <Modal
                isOpen={isDeleteModalOpen}
                title="Confirm Deletion"
                message="Are you sure you want to delete your mine? Deleting it will permanently remove all associated data collected so far."
                onClose={() => setIsDeleteModalOpen(false)}
            >
                <div className="button-group">
                    <button
                        type="button"
                        className="sign-button button"
                        onClick={() => setIsDeleteModalOpen(false)}
                    >
                        Keep Mine
                    </button>
                    <button
                        type="button"
                        className="sign-button button dangerbutton"
                        onClick={handleDeleteMine}
                    >
                        Delete Mine Permanently
                    </button>
                </div>
            </Modal>
        </>
    );
}

export default Mines;
